import React, { useState, useEffect } from "react";
import MainCalculatorsList from "../OtherCalculator/CountriesMainCalculatorsList/SAMainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const TITLE = "حاسبة التوزيع الطبيعي لتقييم الموظفين";
const DESCRIPTION =
  "احسب توزيع تقييمات الموظفين وفق نظام التوزيع الطبيعي المعتمد في الخدمة المدنية السعودية. أدخل عدد الموظفين واحصل فوراً على عدد من يحصل على تقييم 5 و4 و3 وأقل.";
const KEYWORDS =
  "توزيع طبيعي تقييم موظفين, حاسبة التقييم الوظيفي, نظام التوزيع الطبيعي, تقييم الأداء الوظيفي, نسبة تقييم موظفين, حاسبة الخدمة المدنية, توزيع الدرجات الوظيفية";
const OG_URL =
  "https://do-calculate.com/calculator/ar/countries/SA/calculators-list/performance-distribution-calculator/";

function PerformanceDistributionCalculator() {
  const [totalEmployees, setTotalEmployees] = useState("");
  const [result, setResult] = useState(null);

  const handleReset = () => {
    setTotalEmployees("");
  };

  useEffect(() => {
    const total = parseInt(totalEmployees);
    if (!totalEmployees || isNaN(total) || total < 1) {
      setResult(null);
      return;
    }
    const rating5 = Math.floor(total * 0.20);
    const rating4 = Math.floor(total * 0.25);
    const rating3 = total - rating5 - rating4;
    const pct5 = ((rating5 / total) * 100).toFixed(1);
    const pct4 = ((rating4 / total) * 100).toFixed(1);
    const pct3 = ((rating3 / total) * 100).toFixed(1);
    setResult({ total, rating5, rating4, rating3, pct5, pct4, pct3 });
  }, [totalEmployees]);

  return (
    <div className="rtl" style={{ direction: "rtl" }}>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>

      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ padding: "15px", borderRadius: "5px" }}
          >
            <h1 style={{ fontSize: "22px", margin: 0 }}>{TITLE}</h1>
          </div>
          <div className="border border-light mt-3 p-3 bg-white shadow-sm">
            <div className="mb-4">
              <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
                <strong>حاسبة التوزيع الطبيعي لتقييم الموظفين</strong> تساعدك على توزيع درجات
                تقييم الأداء الوظيفي وفق النسب المعتمدة في الخدمة المدنية السعودية. أدخل إجمالي
                عدد الموظفين وستظهر النتيجة فوراً دون الحاجة للضغط على أي زر. يشمل العدد
                الإداريين والمستخدمين وبند الأجور.
              </p>
            </div>
            <hr />
            <MobileUnderCalAds />

            <div className="calculatorStyle mb-4">
              <div className="p-3 mb-3 bg-success text-white text-center rounded">
                <h2 style={{ fontSize: "18px", margin: 0 }}>
                  أدخل عدد الموظفين لحساب توزيع التقييمات
                </h2>
              </div>

              <div className="row">
                <div className="col-sm-12 col-md-6">
                  <label htmlFor="totalEmployees">
                    كم عدد الموظفين؟
                    <span style={{ fontSize: "13px", color: "#666", display: "block" }}>
                      (يشمل الإداريين والمستخدمين وبند الأجور)
                    </span>
                  </label>
                  <input
                    id="totalEmployees"
                    type="number"
                    className="form-control"
                    value={totalEmployees}
                    onChange={(e) => setTotalEmployees(e.target.value)}
                    placeholder="مثال: 32"
                    min="1"
                    style={{ textAlign: "center", fontSize: "18px" }}
                  />
                </div>
              </div>

              <div className="text-center mb-3 mt-4">
                <button
                  onClick={handleReset}
                  className="btn btn-secondary"
                  style={{ fontSize: "16px", padding: "10px 30px" }}
                >
                  امسح
                </button>
              </div>

              {result && (
                <div className="mt-4">
                  <h3 style={{ fontSize: "18px", marginBottom: "15px", textAlign: "center" }}>
                    <strong>نتيجة التوزيع لـ {result.total} موظف:</strong>
                  </h3>

                  {/* Rating 5 */}
                  <div
                    style={{
                      backgroundColor: "#d4edda",
                      border: "1px solid #c3e6cb",
                      borderRadius: "8px",
                      padding: "16px 20px",
                      marginBottom: "12px",
                      position: "relative",
                    }}
                  >
                    <span
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "14px",
                        fontSize: "13px",
                        color: "#666",
                      }}
                    >
                      {result.pct5}%
                    </span>
                    <div style={{ textAlign: "center", fontSize: "42px", fontWeight: "bold", color: "#155724", lineHeight: 1.1 }}>
                      {result.rating5}
                    </div>
                    <div style={{ textAlign: "center", fontSize: "16px", color: "#155724", marginTop: "4px" }}>
                      موظف يحصل على تقييم <strong>5</strong> (ممتاز)
                    </div>
                  </div>

                  {/* Rating 4 */}
                  <div
                    style={{
                      backgroundColor: "#cce5ff",
                      border: "1px solid #b8daff",
                      borderRadius: "8px",
                      padding: "16px 20px",
                      marginBottom: "12px",
                      position: "relative",
                    }}
                  >
                    <span
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "14px",
                        fontSize: "13px",
                        color: "#666",
                      }}
                    >
                      {result.pct4}%
                    </span>
                    <div style={{ textAlign: "center", fontSize: "42px", fontWeight: "bold", color: "#004085", lineHeight: 1.1 }}>
                      {result.rating4}
                    </div>
                    <div style={{ textAlign: "center", fontSize: "16px", color: "#004085", marginTop: "4px" }}>
                      موظف يحصل على تقييم <strong>4</strong> (جيد جداً)
                    </div>
                  </div>

                  {/* Rating 3 or less */}
                  <div
                    style={{
                      backgroundColor: "#fff3cd",
                      border: "1px solid #ffeeba",
                      borderRadius: "8px",
                      padding: "16px 20px",
                      marginBottom: "12px",
                      position: "relative",
                    }}
                  >
                    <span
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "14px",
                        fontSize: "13px",
                        color: "#666",
                      }}
                    >
                      {result.pct3}%
                    </span>
                    <div style={{ textAlign: "center", fontSize: "42px", fontWeight: "bold", color: "#856404", lineHeight: 1.1 }}>
                      {result.rating3}
                    </div>
                    <div style={{ textAlign: "center", fontSize: "16px", color: "#856404", marginTop: "4px" }}>
                      موظف يحصل على تقييم <strong>3 وأقل</strong>{" "}
                      (ويمكن إعطاء الجميع 3)
                    </div>
                  </div>

                  {/* Verification */}
                  <div className="alert alert-secondary text-center mt-3" style={{ fontSize: "14px" }}>
                    {result.rating5} + {result.rating4} + {result.rating3} = <strong>{result.total} موظف</strong>
                  </div>

                  {/* Islamic reminder */}
                  <div
                    className="mt-4"
                    style={{
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      padding: "16px",
                      backgroundColor: "#fafafa",
                      textAlign: "center",
                      fontSize: "14px",
                      lineHeight: "2",
                      color: "#555",
                      fontStyle: "italic",
                    }}
                  >
                    
                  </div>
                </div>
              )}
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
            </div>
          </div>
        </div>

        <div className="col-sm-12 col-md-4">
          <SecondAds />
          <br />
          <MainCalculatorsList />
        </div>
      </div>

      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">

            <div className="info-section">
              <div className="info-section-header">
                <strong>ما هو التوزيع الطبيعي في تقييم الموظفين؟</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  التوزيع الطبيعي (أو القسري) لتقييم الموظفين هو نظام يُلزم المديرين بتوزيع
                  درجات التقييم وفق نسب محددة مسبقاً، بدلاً من إعطاء الجميع نفس الدرجة. النسب
                  المعتمدة في الخدمة المدنية السعودية هي:
                </p>
                <table className="table bmi-table" style={{ width: "100%" }}>
                  <thead>
                    <tr>
                      <th className="bmi-header" style={{ textAlign: "center" }}>التقييم</th>
                      <th className="bmi-header" style={{ textAlign: "center" }}>الوصف</th>
                      <th className="bmi-header" style={{ textAlign: "center" }}>النسبة</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={{ textAlign: "center" }}><strong>5</strong></td>
                      <td style={{ textAlign: "center" }}>ممتاز</td>
                      <td style={{ textAlign: "center" }}>20%</td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "center" }}><strong>4</strong></td>
                      <td style={{ textAlign: "center" }}>جيد جداً</td>
                      <td style={{ textAlign: "center" }}>25%</td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "center" }}><strong>3 وأقل</strong></td>
                      <td style={{ textAlign: "center" }}>متوسط وما دون</td>
                      <td style={{ textAlign: "center" }}>55%</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="info-section">
              <div className="info-section-header">
                <strong>كيف تعمل الحاسبة؟</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  تعتمد الحاسبة على الصيغة الرسمية للتوزيع الطبيعي:
                </p>
                <ul style={{ lineHeight: "2" }}>
                  <li><strong>تقييم 5 (ممتاز):</strong> عدد الموظفين × 20% (يُقرَّب للأسفل)</li>
                  <li><strong>تقييم 4 (جيد جداً):</strong> عدد الموظفين × 25% (يُقرَّب للأسفل)</li>
                  <li><strong>تقييم 3 وأقل:</strong> الباقي = إجمالي الموظفين − تقييم 5 − تقييم 4</li>
                </ul>
                <div className="alert alert-info mt-3" style={{ fontSize: "14px" }}>
                  <strong>💡 ملاحظة:</strong> يُسمح للمدير منح تقييم 3 (متوسط) لجميع من في هذه
                  الفئة، ولا يُلزم بإعطاء تقييم 1 أو 2.
                </div>
              </div>
            </div>

            <div className="info-section">
              <div className="info-section-header">
                <strong>الهدف من التوزيع الطبيعي</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  يهدف نظام التوزيع الطبيعي إلى:
                </p>
                <ul style={{ lineHeight: "2" }}>
                  <li>منع المجاملة في التقييم وإعطاء الجميع درجات عالية دون وجه حق</li>
                  <li>التمييز بين الموظفين المتميزين والمتوسطين بشكل عادل</li>
                  <li>ربط الترقية والمكافآت بالأداء الفعلي لا بالمنصب أو العلاقات</li>
                  <li>تحفيز الموظفين على التطوير والمنافسة الإيجابية</li>
                </ul>
                <div className="alert alert-warning mt-3" style={{ fontSize: "14px" }}>
                  ⚠️ <strong>تنبيه:</strong> هذه الحاسبة للاستخدام الإرشادي. يرجى الرجوع إلى
                  لوائح جهة عملك والأنظمة الرسمية الصادرة عن{" "}
                  <a href="https://hrsd.gov.sa" target="_blank" rel="noopener noreferrer">
                    وزارة الموارد البشرية والتنمية الاجتماعية
                  </a>.
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default PerformanceDistributionCalculator;
